import { CookieKey } from "@/app/vars/Storage";

export class UCookie {
  public static read(key: CookieKey): string | undefined {
    if (typeof document === "undefined") {
      return undefined;
    }

    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${key}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : undefined;
  }

  public static readNumber(key: CookieKey): number | undefined {
    return UCookie.parseNumber(UCookie.read(key));
  }

  public static parseNumber(raw?: string | null): number | undefined {
    if (!raw) {
      return undefined;
    }
    const parsed = parseInt(raw, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
  }

  public static write(key: CookieKey, value: string, maxAge: number): void {
    if (typeof document === "undefined") {
      return;
    }

    document.cookie = `${key}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; samesite=lax`;
  }

  public static remove(key: CookieKey): void {
    if (typeof document === "undefined") {
      return;
    }

    document.cookie = `${key}=; path=/; max-age=0; samesite=lax`;
  }

  public static removeByPrefix(prefix: string): void {
    if (typeof document === "undefined") {
      return;
    }

    const hostParts = window.location.hostname.split(".");
    const domains = hostParts.map((_, index) => hostParts.slice(index).join("."));
    const names = document.cookie
      .split(";")
      .map((cookie) => cookie.split("=")[0].trim())
      .filter((name) => name.startsWith(prefix));

    for (const name of names) {
      document.cookie = `${name}=; path=/; max-age=0`;
      for (const domain of domains) {
        document.cookie = `${name}=; path=/; max-age=0; domain=.${domain}`;
      }
    }
  }
}
